import React, { useState, useEffect } from "react";
import { Card, Typography, Space, Statistic, Button } from "antd";
import {
	BookOutlined,
	CheckCircleOutlined,
	ClockCircleOutlined,
	StopOutlined,
	SettingOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import useAxios, { getCurrentUser } from "../../utilities/useAxios";
import PageTitle from "../PageTitle";
import MyEnrollments from "./MyEnrollments";

const { Title, Text } = Typography;

const Cma = () => {
	const [overallStats, setOverallStats] = useState(null);
	const [user, setUser] = useState(null);
	const [isCmaStaff, setIsCmaStaff] = useState(false);
	const navigate = useNavigate();

	const isTokenValid = () => {
		return localStorage.getItem("access") !== null;
	};

	useEffect(() => {
		const currentUser = getCurrentUser();
		setUser(currentUser);
		if (currentUser) {
			fetchOverallStats();
		}
		if (isTokenValid()) {
			const groupStr = localStorage.getItem("user_groups");
			if (groupStr) {
				try {
					const groups = JSON.parse(groupStr);
					setIsCmaStaff(
						groups.includes("cma_staff")
					);
				} catch (error) {
					console.error(
						"Error parsing user groups:",
						error
					);
				}
			}
		}
	}, []);

	const fetchOverallStats = async () => {
		try {
			const response = await useAxios.get(
				"/cma/progress/overall/"
			);
			setOverallStats(response.data);
		} catch (error) {
			console.error("Error fetching overall stats:", error);
		}
	};

	const renderStatsCard = () => {
		if (!overallStats) return null;

		return (
			<Card className="cma__stats-card">
				<Space
					size="large"
					className="cma__stats-space"
					style={{
						width: "100%",
						justifyContent: "space-around",
					}}>
					<Statistic
						title="전체 강의"
						value={
							overallStats.total_courses
						}
						prefix={<BookOutlined />}
						className="cma__statistic"
						valueStyle={{
							color: "#2457e6",
						}}
					/>
					<Statistic
						title="수료 완료"
						value={
							overallStats.completed_courses
						}
						prefix={<CheckCircleOutlined />}
						className="cma__statistic"
						valueStyle={{
							color: "#52c41a",
						}}
					/>
					<Statistic
						title="진행 중"
						value={
							overallStats.in_progress_courses
						}
						prefix={<ClockCircleOutlined />}
						className="cma__statistic"
						valueStyle={{
							color: "#faad14",
						}}
					/>
					<Statistic
						title="미시작"
						value={
							overallStats.not_started_courses
						}
						prefix={<StopOutlined />}
						className="cma__statistic"
						valueStyle={{
							color: "#8c8c8c",
						}}
					/>
				</Space>
			</Card>
		);
	};

	if (!user) {
		return (
			<div style={{ textAlign: "center", padding: "50px" }}>
				<Text>사용자 정보를 불러오는 중...</Text>
			</div>
		);
	}

	return (
		<div className="cma__container">
			<PageTitle title="기독사관학교 - 나의 강의실" />
			<Card className="cma__header-card">
				<Title level={1} className="cma__header-title">
					나의 강의실
				</Title>
			</Card>

			{renderStatsCard()}

			{/* Admin Button for Staff */}
			{isCmaStaff && (
				<Card className="cma__admin-card">
					<Space
						direction="vertical"
						style={{ width: "100%" }}>
						<Button
							type="primary"
							icon={
								<SettingOutlined />
							}
							size="large"
							className="cma__admin-button"
							onClick={() =>
								navigate(
									"/cma/admin"
								)
							}>
							관리자 페이지
						</Button>
						<Text
							type="secondary"
							className="cma__admin-text">
							강의 관리 및 수강생
							현황을 확인하세요
						</Text>
					</Space>
				</Card>
			)}

			<Card className="cma__enrollments-card">
				<Title
					level={3}
					className="cma__enrollments-title">
					수강 신청 내역
				</Title>
				<MyEnrollments
					onEnrollmentUpdate={() =>
						fetchOverallStats()
					}
				/>
			</Card>
		</div>
	);
};

export default Cma;
